import React from 'react';

const StrategicMessage = () => (
  <div className="alert-dialog" role="alert">
    <span className="icon icon-lg dls-icon-warning dls-red" />
    <h2 className="dls-gray-05 margin-1-tb">
      Warning, this is a test page.
    </h2>
  </div>
);

export default StrategicMessage;
